<header class="mb-2 flex shrink-0 items-center justify-between border-b border-mainColorLight p-2">
	@if (title()) {
		<h2 class="min-w-0 flex-1 ps-2 text-lg font-bold leading-snug text-mainColor">
			{{ title() }}
		</h2>
	} @else {
		<span class="flex-1"></span>
	}

	<button
		type="button"
		mat-dialog-close
		class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full transition-colors hover:bg-mainColorHoverBg"
		aria-label="Zamknij"
	>
		<i class="fa-solid fa-xmark text-xl text-mainColor" aria-hidden="true"></i>
	</button>
</header>

<div class="mobile-dialog__body min-h-0 flex-1 overflow-hidden px-2">
	<ng-container #dynamicContent></ng-container>
</div>

@if (hasFooter()) {
	<footer class="mobile-dialog__footer shrink-0 border-t border-mainColorLight bg-white">
		<ng-container #footerContent></ng-container>
	</footer>
}
